export const ValidateEmailDirectiveModule = angular
    .module('app.directives.validateEmail', [])
    .directive('vlnValidateEmail', () => {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: (scope, element, attrs, ngModelCtrl) => {
                ngModelCtrl.$validators.validEmail = (modelValue, viewValue) => {
                    let value = modelValue || viewValue;
                    if (!value) return true;
                    return /.+@.+\.[^\s]+/.test(value);
                };
            }
        };
    }).name;


// WEBPACK FOOTER //
// ./src/app/directives/validateEmail.directive.js